<template>
  <div>
    <router-view></router-view >
    <PageHeaderLayout v-show="this.$route.matched.length==2">
      <div class="main-page-content">
        <!-- 页面标题区域 -->
        <div class="page-title-section">
          <div class="title-content">
            <h1 class="page-title">
              <i class="el-icon-cpu"></i>
              工艺分类管理
            </h1>
            <p class="page-subtitle">管理工艺分类信息，包含工艺类型、材料配置和状态管理</p>
          </div>
        </div>

        <!-- 操作面板 -->
        <div class="action-card">
          <div class="action-buttons">
            <el-tooltip effect="dark" content="添加工艺分类" placement="top">
              <el-button type="primary" size="mini" icon="el-icon-plus" @click="addButton()">添加细分工艺</el-button>
            </el-tooltip>
          </div>
        </div>

        <!-- 搜索筛选卡片 -->
        <div class="search-card">
          <div class="search-header">
            <i class="el-icon-search"></i>
            <span>筛选条件</span>
          </div>
          <div class="search-content">
            <el-form size="mini" :inline="true" :model="searchCondition" class="search-form">
              <el-form-item>
                <el-input v-model="searchCondition.category_name" placeholder="请输入工艺名称" clearable prefix-icon="el-icon-cpu">
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="mini" icon="el-icon-search" @click="searchButton">查询</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <!-- 表格卡片 -->
        <div class="table-card">
          <ApeTable ref="apeTable" :data="dataList" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row>
            <el-table-column width="60" align="center" label="排序">
              <template slot-scope="scope">
                <el-tooltip effect="dark" content="拖动排序" placement="top">
                  <span class="drag-handle" :data-id="scope.row.id" :data-parent_id="scope.row.pid" :data-depth="scope.row.depth">
                    <i class="el-icon-rank"></i>
                  </span>
                </el-tooltip>
              </template>
            </el-table-column>

            <el-table-column width="60" label="序号" align="center">
              <template slot-scope="scope">
                <span class="sequence-number">{{offset+scope.$index+1}}</span>
              </template>
            </el-table-column>

            <el-table-column label="工艺图片" width="120" align="center">
              <template slot-scope="scope">
                <div class="craft-image">
                  <img :src="getallUrl(scope.row.craft_image)" alt="工艺图片">
                </div>
              </template>
            </el-table-column>

            <el-table-column label="工艺信息" min-width="200">
              <template slot-scope="scope">
                <div class="craft-info">
                  <div class="info-row">
                    <i class="el-icon-setting"></i>
                    <span class="info-label">加工方式：</span>
                    <span class="info-value">{{scope.row.craft_title}}</span>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-document"></i>
                    <span class="info-label">工艺内容：</span>
                    <span class="info-value">{{scope.row.craft_content}}</span>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="真空覆模" width="100" align="center">
              <template slot-scope="scope">
                <div class="vacuum-status">
                  <el-tag :type="scope.row.vacuum_casting=='1'?'success':'info'" size="mini">
                    <i :class="scope.row.vacuum_casting=='1'?'el-icon-check':'el-icon-close'"></i>
                    {{scope.row.vacuum_casting=='1'?'是':'否'}}
                  </el-tag>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="工艺描述" min-width="160">
              <template slot-scope="scope">
                <div class="craft-desc">
                  <el-tooltip :content="scope.row.craft_desc" placement="top" :disabled="!scope.row.craft_desc || scope.row.craft_desc.length <= 50">
                    <span class="desc-text">{{scope.row.craft_desc | truncate(50)}}</span>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="盈利系数" width="100" align="center">
              <template slot-scope="scope">
                <div class="profit-coefficient">
                  <el-tag type="warning" size="mini">
                    <i class="el-icon-s-finance"></i>
                    {{scope.row.profit_coefficient}}
                  </el-tag>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="状态" width="80" align="center">
              <template slot-scope="scope">
                <el-switch 
                  v-model="scope.row.craft_category_status" 
                  :active-value="'1'" 
                  :inactive-value="'0'" 
                  @change="changeStatus(scope.row)"
                  active-color="#67c23a"
                  inactive-color="#f56c6c">
                </el-switch>
              </template>
            </el-table-column>

            <el-table-column v-if="buttonType=='icon'" width="120" label="操作" align="center">
              <template slot-scope="scope">
                <div class="action-buttons">
                  <el-tooltip effect="dark" content="编辑" placement="top">
                    <el-button size="mini" icon="el-icon-edit" circle type="primary" @click="editButton(scope.row.id)"></el-button>
                  </el-tooltip>
                  <el-tooltip effect="dark" content="工艺材料" placement="top">
                    <el-button size="mini" icon="el-icon-files" circle type="success" @click="getMaterial(scope.row.id)"></el-button>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </ApeTable>
        </div>
      </div>
    </PageHeaderLayout>

    <ApeDrawer :drawerData="drawerData" @drawerClose="drawerClose" @drawerConfirm="drawerConfirm">
      <template slot="ape-drawer">
        <el-form :model="formData" :rules="rules" ref="dataForm" label-position="right" label-width="96px">
          <el-row>
            <el-col :span="22">
              <el-form-item label="工艺名称" prop="craft_title">
                <el-input v-model="formData.craft_title" prefix-icon="el-icon-setting"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="状态" prop="craft_category_status">
                <el-select v-model="formData.craft_category_status" placeholder="请选择">
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="真空铸造" prop="vacuum_casting">
                <el-select v-model="formData.vacuum_casting" placeholder="请选择">
                  <el-option v-for="item in vacuum_castings" :key="item.label" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="工艺内容" prop="craft_content">
                <el-input v-model="formData.craft_content" type="textarea" :rows="3"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="工艺描述" prop="craft_desc">
                <el-input v-model="formData.craft_desc" type="textarea" :rows="3"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="盈利系数" prop="profit_coefficient">
                <el-input v-model="formData.profit_coefficient" prefix-icon="el-icon-s-finance">
                  <template slot="append">%</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="工艺图片" prop="craft_image">
                <ApeUploader :limit="1" @handleUploadSuccess="handleUploadSuccess" @handleUploadRemove="handleUploadRemove" :upload-file-list="uploadFileList"></ApeUploader>
              </el-form-item>
            </el-col>
          </el-row>
          <I18nTranslatePanel entity-type="craft_category" :entity-id="formData.id || ''" />
        </el-form>     
      </template>
    </ApeDrawer>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import { mapGetters } from 'vuex'
import Sortable from 'sortablejs'
import ApeUploader from '@/components/ApeUploader'
import I18nTranslatePanel from '@/components/I18nTranslatePanel'
export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    ApeDrawer,
    ApeUploader,
    I18nTranslatePanel
  },
  data() {
    return {
      // 搜索条件
      searchCondition:{
        page_offset: 1,
        page_size: 20,
        craft_id: "",
        order_by: "craft_category_rank asc",
      },
      loadingStaus: true,
      // 表格列表数据
      dataList:[],
      uploadFileList:[],
      // 分页信息
      pagingData:{
        is_show: true,
        page_size: 20,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      // 表单结构
      formData: {
        id:0
      },
      // 表单验证
      rules: {
        CraftCategory_name: [{required: true,message:'输入工艺名称', trigger: 'blur' }],
        CraftCategory_desc: [{required: true,message:'输入工艺描述', trigger: 'blur' }],
      },
      vacuum_castings:[
        {
          label:'否',
          value:'0'
        },
        {
          label:'是',
          value:'1'
        }
      ],
      // 抽屉数据
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '玩命加载中……',
        title: '权限绑定',
        width_height: '580px',
      },
      rolesList: [],
      userRoles: []
      
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType'])
  },
  methods: {
    // 搜索
    searchButton() {
      this.list()
    },
    // 切换页码操作
    async switchPaging() {
      this.list()
    },
    async changeStatus(row) {
      let res = await this.$api.post('/service/ola_app_craft_category/update',row)
      if (this.$apiSuccess(res)){
        this.$message.success('保存成功!')
        this.list()
      }
    },
    handleUploadSuccess(file, fileList) {
      this.formData.craft_image = file
      this.uploadFileList = fileList
    },
    // 图片删除回调
    handleUploadRemove(file, fileList) {
      this.formData.craft_image = 0
      this.uploadFileList = fileList
    },
    // 响应添加按钮
    async addButton() {
      this.formData = {}
      this.formData.id = ''
      this.drawerData.visible = true
      this.drawerData.title = '添加数据'
      this.drawerData.loading = false
    },
    // 响应编辑按钮
    async editButton(id) {
      this.drawerData.loading_text = '玩命加载中……'
      this.drawerData.visible = true
      this.drawerData.title = '编辑数据(UID：'+id+')'
      let res = await this.$api.post('/service/ola_app_craft_category/detail',{id:id})
      if (this.$apiSuccess(res)){
        this.formData = res.data.detail
        if (res.data.detail.craft_image !='' ){
          this.uploadFileList = [{url:this.getallUrl(res.data.detail.craft_image)}]
        }
      }else{
        this.$message.error(res.message)
      }
      this.drawerData.loading = false
    },
    // 处理抽屉关闭
    drawerClose() {
      this.initFormData()
      this.drawerData.visible = false
      this.drawerData.loading = true
      this.rolesList = []
    },
    // 处理抽屉确认
    async drawerConfirm() {
      // 调用组件的数据验证方法
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // form数据提交，请求接口
    async formSubmit() {
      this.drawerData.loading_text = '玩命提交中……'
      this.drawerData.loading = true
      let url = '/service/ola_app_craft_category/create'
      if(this.formData.id!=''){
        url = '/service/ola_app_craft_category/update'
      }
      this.formData.craft_id = this.$route.params.id
      let res = await this.$api.post(url,this.formData)
      if (this.$apiSuccess(res)){
        this.$message.success('保存成功!')
        this.initFormData()
      }else{
        this.$message.error(res.message)
      }
      this.drawerData.visible = false
      this.drawerData.loading = true
      this.initFormData()
    },
    // row数据提交，请求接口
    async rowSubmit(row) {
      this.drawerData.loading_text = '玩命提交中……'
      this.drawerData.loading = true
      if(row.status=='0'){
        row.status='1'
      }else{
        row.status='0'
      }
      let id = await this.$api.modifyCraftCategory(row)
      this.$nextTick(() => {
        this.drawerData.visible = false
      })
      this.$nextTick(async () => {
        if (id) {
          this.list()
        }
      })
      this.$nextTick(() => {
        this.$message.success('保存成功!')
      })
      this.initFormData()
    },
    // 相应删除按钮
    async deleteButton(id) {
      let res = await this.$api.deleteCraftCategory(id)
      if (res.info == null) {
        this.$message.success('删除成功!')
        this.$nextTick(async () => {
          this.list()
        })
      } else {
        this.$message.error(info)
      }
      
    },
    // 初始化数据
    initFormData() {
      // 初始化form表单
      this.$nextTick(() => {
        this.formData = {id:0}
        this.$refs['dataForm'].resetFields()
      })
    },
    async getMaterial(id) {
      window.open('/craft/category/'+id+'/material', '_blank');
    },
    // 初始化数据列表
    async list() {
      this.loadingStaus=true
      let pagingInfo = this.$refs['apeTable'].getPagingInfo()
      Object.assign(this.searchCondition,pagingInfo)
      this.searchCondition.query = "craft_id=?"
      this.searchCondition.params = [this.$route.params.id]
      let res = await this.$api.post('/service/ola_app_craft_category/list',this.searchCondition)
      if (this.$apiSuccess(res)){
          this.dataList=res.data.list
          this.pagingData.total = res.data.page.total
      }else{
        this.$message.error(res.message)
        this.dataList=[]
      }
      this.loadingStaus=false
    },
    getallUrl(url){
      if(url==null || url=='' || url==undefined){
        return ''
      }
      let s = String(url).trim()
      if(/^https?:\/\//i.test(s)){
        return s.replace(/(https?:\/\/[^/]+)\/+/i, '$1/')
      }
      const origin = String(window.location.origin || '').replace(/\/+$/, '')
      let path = s.replace(/^\/+/, '/')
      if (!path.startsWith('/')) {
        path = '/' + path
      }
      path = path.replace(/\/+/g, '/')
      return origin + path
    },
    // 拖拽排序数据提交，请求接口
    async dragSortSubmit(orderIds) {
      let res = await this.$api.post('/service/ola_app_craft_category/order',{orderIds:orderIds,sort_field:'craft_category_rank'})
      if (this.$apiSuccess(res)){
        this.$message.success('排序成功!')
        this.list()
      }else{
        this.$message.error('排序失败!')
      }
    },
    // 表格拖拽排序，同层级移动有效果
    dragSort() {
      const el = document.querySelectorAll('.el-table__body-wrapper > table > tbody')[0]
      this.sortable = Sortable.create(el,{
        handle: ".drag-handle", 
        setData: function(dataTransfer) {
          dataTransfer.setData('Text', '')
        },
        onEnd: () => {
          let Ids = []
          let tmp = el.querySelectorAll('.drag-handle')
          for (let i=0,len=tmp.length; i < len; i++) {
            Ids.push(tmp[i].dataset.id)
          }
          this.dragSortSubmit(Ids)
        },
      })
    }
  },
  mounted() {
    this.list()
    this.$nextTick(() => {
      this.dragSort()
    })
  },
}
</script>

<style lang="stylus" scoped>
// 页面标题区域样式
.page-title-section
  background linear-gradient(135deg, #667eea 0%, #764ba2 100%)
  border-radius 12px
  padding 24px
  margin-bottom 20px
  color white
  
  .title-content
    .page-title
      margin 0 0 8px 0
      font-size 24px
      font-weight 600
      display flex
      align-items center
      
      i
        margin-right 12px
        font-size 28px
    
    .page-subtitle
      margin 0
      opacity 0.9
      font-size 14px

// 操作面板样式
.action-card
  background white
  border-radius 12px
  padding 16px 20px
  margin-bottom 20px
  box-shadow 0 2px 12px rgba(0, 0, 0, 0.08)
  
  .action-buttons
    display flex
    gap 8px

// 搜索卡片样式
.search-card
  background white
  border-radius 12px
  padding 20px
  margin-bottom 20px
  box-shadow 0 2px 12px rgba(0, 0, 0, 0.08)
  
  .search-header
    display flex
    align-items center
    margin-bottom 16px
    font-weight 600
    color #303133
    
    i
      margin-right 8px
      color #409eff
  
  .search-content
    .search-form
      margin 0
      
      /deep/ .el-form-item
        margin-bottom 0
        margin-right 20px

// 表格卡片样式
.table-card
  background white
  border-radius 12px
  padding 20px
  box-shadow 0 2px 12px rgba(0, 0, 0, 0.08)
  
  /deep/ .el-table
    border-radius 8px
    overflow hidden
    
    th
      background #f8f9fa
      color #303133
      font-weight 600
      border-bottom 2px solid #e4e7ed
    
    td
      border-bottom 1px solid #f0f0f0
    
    tr:hover
      background #f5f7fa

// 序号样式
.sequence-number
  display inline-flex
  align-items center
  justify-content center
  width 24px
  height 24px
  background #409eff
  color white
  border-radius 50%
  font-size 12px
  font-weight 600

// 拖拽排序样式
.drag-handle
  font-size 18px
  cursor move
  color #409eff
  
  &:hover
    color #66b1ff

// 工艺图片样式
.craft-image
  img
    width 80px
    height 80px
    border-radius 8px
    object-fit cover
    border 2px solid #e4e7ed
    
    &:hover
      border-color #409eff
      transform scale(1.05)
      transition all 0.3s ease

// 工艺信息样式
.craft-info
  .info-row
    display flex
    align-items center
    margin-bottom 6px
    font-size 12px
    
    i
      color #409eff
      margin-right 6px
      font-size 14px
      width 14px
    
    .info-label
      color #909399
      margin-right 4px
      font-weight 500
      min-width 70px
    
    .info-value
      color #303133
      font-weight 500

// 真空状态样式
.vacuum-status
  .el-tag
    border-radius 12px
    
    i
      margin-right 4px

// 工艺描述样式
.craft-desc
  .desc-text
    color #303133
    line-height 1.4
    font-size 12px

// 盈利系数样式
.profit-coefficient
  .el-tag
    border-radius 12px
    
    i
      margin-right 4px

// 操作按钮样式
.action-buttons
  display flex
  gap 6px
  justify-content center
  
  .el-button.is-circle
    padding 6px
    
    &:hover
      transform translateY(-2px)
      transition all 0.3s ease

// 响应式设计
@media (max-width: 768px)
  .page-title-section
    padding 16px
    
    .page-title
      font-size 20px
  
  .search-content
    .search-form
      /deep/ .el-form-item
        margin-right 10px
        margin-bottom 10px

// 全局样式优化
/deep/ .el-button
  border-radius 6px
  transition all 0.3s ease
  
  &:hover
    transform translateY(-1px)
    box-shadow 0 4px 12px rgba(64, 158, 255, 0.3)

/deep/ .el-input
  .el-input__inner
    border-radius 6px
    transition all 0.3s ease
    
    &:focus
      box-shadow 0 0 8px rgba(64, 158, 255, 0.2)

/deep/ .el-select
  .el-input__inner
    border-radius 6px

/deep/ .el-tag
  border-radius 6px
  font-weight 500

/deep/ .el-switch
  .el-switch__core
    border-radius 10px
</style>
